module.exports = __webpack_public_path__ + "static/media/Header1.4d56dacc.jpg";